import { defineMessages } from 'react-intl';

export const messages: {
	lastActive: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	threadTypeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	messageTypeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	channelTypeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	channelMemberCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privateConversationText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noContributorsText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalPeopleText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalPersonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleWithRemainingContributors: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleAndChannelName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	messageResultLockIconTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privateChannelLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	lastActive: {
		id: 'search-page.results.product-results.third-party.last-active',
		defaultMessage: 'Last active {relativeDate}',
		description: 'Label for the last active time',
	},
	threadTypeLabel: {
		id: 'search-page.results.product-results.third-party.thread-type-label',
		defaultMessage: 'Thread',
		description: 'Thread metadata label',
	},
	messageTypeLabel: {
		id: 'search-page.results.product-results.third-party.message-type-label',
		defaultMessage: 'Message',
		description: 'Message metadata label',
	},
	channelTypeLabel: {
		id: 'search-page.results.product-results.third-party.channel-type-label',
		defaultMessage: 'Channel',
		description: 'Channel metadata label',
	},
	channelMemberCount: {
		id: 'search-page.results.product-results.third-party.channel-member-count',
		defaultMessage: '{memberCount, plural, one {# member} other {# members}}',
		description: 'Label for the number of members in a channel',
	},
	privateConversationText: {
		id: 'search-page.results.product-results.third-party.private-conversation-text',
		defaultMessage: '{users} in a private conversation',
		description: 'Label for a private conversation',
	},
	noContributorsText: {
		id: 'search-page.results.product-results.third-party.no-contributors-label',
		defaultMessage: 'External people in #{channelName}',
		description: 'Text for no contributors in the search result title',
	},
	externalPeopleText: {
		id: 'search-page.results.product-results.third-party.external-people-label',
		defaultMessage: 'External people',
		description: 'Text for external people in the search result title',
	},
	externalPersonText: {
		id: 'search-page.results.product-results.third-party.external-person-label',
		defaultMessage: 'External person',
		description: 'Text for external person in the search result title',
	},
	titleWithRemainingContributors: {
		id: 'search-page.results.product-results.third-party.title-with-remaining-contributors',
		defaultMessage:
			'{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}',
		description: 'Label for the title with remaining contributors',
	},
	titleAndChannelName: {
		id: 'search-page.results.product-results.third-party.title-and-channel-name',
		defaultMessage: '{title} in #{channelName}',
		description: 'Label for the title and channel name',
	},
	messageResultLockIconTooltip: {
		id: 'search-page.results.product-results.third-party.message-search-result.message-result-lock-icon-tooltip',
		defaultMessage: 'Restricted - Only specific people can see this result',
		description: 'Use to describe the lock icon on a message search result that is restricted',
	},
	privateChannelLabel: {
		id: 'search-result.private-channel-label',
		defaultMessage: 'Private Channel',
		description: 'Private channel metadata label',
	},
});
